<template>
  <canvas width="500" height="250"></canvas>
</template>

<script>
import datalabels from 'chartjs-plugin-datalabels'
import moment from 'moment'
import Chart from 'chart.js'

const totalizer = {
  id: 'totalizer',

  beforeUpdate: chart => {
    let totals = {}
    let utmost = 0

    chart.data.datasets.forEach((dataset, datasetIndex) => {
      if (chart.isDatasetVisible(datasetIndex)) {
        utmost = datasetIndex

        dataset.data.forEach((value, index) => {
          totals[index] = (totals[index] || 0) + value
        })
      }
    })

    chart.$totalizer = {
      totals: totals,
      utmost: utmost
    }
  }
}

export default {
  props: ['activity'],

  mounted() {
    this.$nextTick(this.draw)
  },

  methods: {
    draw() {
      new Chart(this.$el.getContext('2d'), {
        plugins: [datalabels, totalizer],

        type: 'bar',

        data: {
          labels: this.activity.attributes.months,
          datasets: [
            {
              label: 'Content From Partner',
              data: this.activity.attributes.person_content_by_month,
              backgroundColor: '#e8384f'
            },
            {
              label: 'Content From Support',
              data: this.activity.attributes.user_content_by_month,
              backgroundColor: '#fd612c'
            }
          ]
        },

        options: {
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true,
              ticks: {
                beginAtZero: true
              }
            }]
          },

          legend: {
            position: 'bottom'
          },

          layout: {
            padding: {
              top: 25
            }
          },

          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              formatter: (value, ctx) => ctx.chart.$totalizer.totals[ctx.dataIndex],
              display: (ctx) => ctx.datasetIndex === ctx.chart.$totalizer.utmost
            }
          }
        }
      });
    },
  }
}
</script>
